import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../BaseUrl";

export const getComparativeView = createAsyncThunk(
    "/store/get-comparative-view",
    async (id) => {
        try {
            const myurl = `${V_URL}/prosafe/quotation/${id}/comparative`;

            const response = await axios({
                method: "get",
                url: myurl,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("PAY_USER_TOKEN"),
                },
            });

            const data = response.data;

            if (data?.success === true) {
                return data;
            } else {
                throw new Error(data.message || "Failed to fetch comparative data");
            }
        } catch (error) {
            console.error("Comparative API Error:", error);
            const errorMsg = error?.response?.data?.message || error.message || "Error fetching comparative data";
            toast.error(errorMsg);
            throw error; 
        }
    }
);

const initialState = {
    user: null,
    loading: false,
    error: null,
};

const getComparativeViewSlice = createSlice({
    name: "getComparativeView",
    initialState,
    reducers: {
        resetGetComparativeView: (state) => {
            state.user = null;
            state.loading = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getComparativeView.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getComparativeView.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(getComparativeView.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export const { resetGetComparativeView } = getComparativeViewSlice.actions;

export default getComparativeViewSlice.reducer;
